import React from "react";
import { Card } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import CreateSessionReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import SearchTwoIntReq from "../../../Classes/Models/Requests/SearchTwoIntReq";
import "./contract-search.scss";
import AccountingApi from "Classes/API/AccountingApi";
import Pagination from "@mui/material/Pagination";

const UnlinkedSessionsTable = ({ Contract, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: "Name", accessor: "Name", align: "left" },
    { Header: "Action", accessor: "Update", align: "left" },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);
  const [UnlinkedSessions, SetUnlinkedSessions] = useState([]);

  const [PaginationPages, setPaginationPages] = useState(4);
  const [Page, setPage] = useState(1);

  const AddSessionToContract = async (Session) => {
    let childSessionReq = new SearchTwoIntReq();
    childSessionReq.ParentSessionId = Session.id;
    childSessionReq.ContractId = Contract.id;

    var res = await SessionsApi.CreateChildSession(childSessionReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    RefreshTable();
  };

  const getUnlinkedSessions = async () => {
    let updateSessionReq = new SearchStringOrIntReq();
    updateSessionReq.pagingParams.pageNumber = Page;
    updateSessionReq.pagingParams.pageSize = 5;
    updateSessionReq.SearchInt = Contract.id;

    var res = await AccountingApi.GetUnlinkedSessions(updateSessionReq);

    if (res.status == "Success") {
      SetUnlinkedSessions(res.data);
      setPaginationPages(Math.ceil(res.data.totalItems / 5));
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    console.log(PaginationPages);
  };

  const MakeTableRow = (Session) => {
    console.log(Session);
    return {
      Name: (
        <MDTypography
          className="input-data"
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {Session.name}
        </MDTypography>
      ),

      Update: (
        <button className="btn btn-outline-success" onClick={() => AddSessionToContract(Session)}>
          Update
        </button>
      ),
    };
  };

  const RefreshTable = () => {
    var rows = [];
    var resList = UnlinkedSessions.list;
    resList.forEach((UnlinkedSessions, index) => {
      rows.push(MakeTableRow(UnlinkedSessions, index));
    });
    console.log(rows);
    setTableDataRows(rows);
  };

  useEffect(() => {
    getUnlinkedSessions();
  }, [Page]);

  useEffect(() => {
    if (UnlinkedSessions && UnlinkedSessions?.list?.length > 0) {
      RefreshTable();
    } else {
      return (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          No Sessions
        </MDTypography>
      );
    }
  }, [UnlinkedSessions]);

  return (
    <Card className="mt-5">
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography
          variant="h6"
          color="white"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          Contract Sessions
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
      <div className="text-right mx-3 my-4">
        <Pagination
          count={PaginationPages}
          color="primary"
          onChange={(e, num) => setPage(num)}
          className="float-right"
        />
      </div>
    </Card>
  );
};

export default UnlinkedSessionsTable;
